import { render } from "./index.vue?vue&type=template&id=0bb9c6c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0bb9c6c8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0bb9c6c8"

export default script